import request from '@/utils/httpRequest'

export default {
  save: function (inputForm) {
    return request({
      url: '/cecunmsetmealposition/cecUnmSetMealPosition/save',
      method: 'post',
      data: inputForm
    })
  },

  delete: function (ids) {
    return request({
      url: '/cecunmsetmealposition/cecUnmSetMealPosition/delete',
      method: 'delete',
      params: {ids: ids}
    })
  },

  queryById: function (id) {
    return request({
      url: '/cecunmsetmealposition/cecUnmSetMealPosition/queryById',
      method: 'get',
      params: {id: id}
    })
  },

  savePositionIds: function (inputForm) {
    return request({
      url: '/cecunmsetmealposition/cecUnmSetMealPosition/savePositionIds',
      method: 'post',
      data: inputForm
    })
  },

  list: function (params) {
    return request({
      url: '/cecunmsetmealposition/cecUnmSetMealPosition/list',
      method: 'get',
      params: params
    })
  },

  allList: function (params) {
    return request({
      url: '/cecunmsetmealposition/cecUnmSetMealPosition/allList',
      method: 'get',
      params: params
    })
  },

  exportTemplate: function () {
    return request({
      url: '/cecunmsetmealposition/cecUnmSetMealPosition/import/template',
      method: 'get',
      responseType: 'blob'
    })
  },

  exportExcel: function (params) {
    return request({
      url: '/cecunmsetmealposition/cecUnmSetMealPosition/export',
      method: 'get',
      params: params,
      responseType: 'blob'
    })
  },

  importExcel: function (data) {
    return request({
      url: '/cecunmsetmealposition/cecUnmSetMealPosition/import',
      method: 'post',
      data: data
    })
  }
}
